/* eslint-disable global-require */
import config from '../../../../config';

let store;
if (config.devStoreConfig) {
  store = require('./configureStore.dev.js');
} else {
  store = require('./configureStore.prod.js');
}

module.exports = store;



// WEBPACK FOOTER //
// ./src/app/state/store/configureStore.js